<div class="fc content">
  <ng-content select="[content]"></ng-content>
</div>
<div class="fc sidenav">
  <ng-content select="[sidenav]"></ng-content>
</div>
